import { IconType } from "react-icons";
import React from "react";

interface IconProps {
  icon: IconType;
  className?: string;
  onClick?: React.MouseEventHandler<SVGElement>;
  size?: string | number;
  color?: string;
  [key: string]: any;
}

export const Icon: React.FC<IconProps> = ({ icon, className, ...rest }) => {
  const IconComponent = icon as unknown as React.ElementType;
  return <IconComponent className={className} {...rest} />;
};
